import { getExperience } from '../utils/cvParser'
import { Calendar, MapPin, Briefcase } from 'lucide-react'

const Experience = () => {
  const experiences = getExperience()

  const formatDate = (startDate, endDate) => {
    const start = new Date(startDate).toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short' 
    })
    const end = endDate 
      ? new Date(endDate).toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'short' 
        })
      : 'Present'
    return `${start} - ${end}`
  }

  return (
    <section id="experience" className="bg-gray-50">
      <div className="section-container">
        <h2 className="section-title text-center">Professional Experience</h2>
        
        <div className="max-w-4xl mx-auto space-y-8">
          {experiences.map((exp, index) => (
            <div key={index} className="card">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-4">
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {exp.position}
                  </h3>
                  <div className="flex items-center gap-2 text-navy-700 font-semibold mb-2">
                    <Briefcase size={18} />
                    <span>{exp.company}</span>
                  </div>
                </div>
                
                <div className="text-gray-600 md:text-right space-y-1">
                  <div className="flex items-center gap-2 md:justify-end">
                    <Calendar size={16} />
                    <span className="text-sm">
                      {formatDate(exp.start_date, exp.end_date)}
                    </span>
                  </div>
                  {exp.location && (
                    <div className="flex items-center gap-2 md:justify-end">
                      <MapPin size={16} />
                      <span className="text-sm">{exp.location}</span>
                    </div>
                  )}
                </div>
              </div>

              {exp.highlights && exp.highlights.length > 0 && (
                <ul className="space-y-3 mt-4">
                  {exp.highlights.map((highlight, hIndex) => (
                    <li key={hIndex} className="flex gap-3 text-gray-700">
                      <span className="text-navy-600 mt-1 flex-shrink-0">▸</span>
                      <span className="leading-relaxed">{highlight}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Experience
